export const SET_INACTIVE = "SET_INACTIVE";

// Sets errors in store (forms)
export const setInactive = (inactive: boolean) => {
  return {
    type: SET_INACTIVE,
    payload: inactive,
  };
};
